export function getValidParams(params) {
  const parameter = Array.isArray(params) ? params[0] : params;
  const arr = decodeURIComponent(parameter).split('|');
  return /^\d+$/.test(arr[0]) ? arr : [];
}

export function parseVehicleParam(query, name) {
  const [styleId, submodel] = (query[name] && getValidParams(query[name])) || [];
  return {
    name,
    styleId,
    submodel,
  };
}
